import axios, { AxiosInstance, AxiosResponse } from 'axios'
import { ElMessage } from 'element-plus'
import { RequestConfigType, ResponseType } from './types'
import { useLanguageStore } from '@/store/modules/language'
import { UseVerifyAccount } from '@/views/mall/verifyAccount/useVerifyAccount'
import { CommonConstants } from '@/common/constants'
import { AxiosCanceler } from './axiosCancel'
import { UseReportData } from '@/hooks/useReportData'

console.log('VUE_APP_API_BASE_URL', process.env.VUE_APP_API_BASE_URL)

const axiosCanceler = new AxiosCanceler()

// 创建axios实例
const instance: AxiosInstance = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 120 * 1000, // 超时
  headers: {
    'Content-Type': 'application/json'
  }
})

// 请求错误处理
const onError = (error: any) => {
  if (error.message.includes('timeout')) {
    ElMessage({
      message: 'request timeout',
      type: 'error'
    })
  }
  return error
}

// 请求拦截
instance.interceptors.request.use((config: any) => {
  const isCancel = config.data?.data?.cancelAxios ?? false
  isCancel && axiosCanceler.addPending(config)

  config.headers = {
    ...config.headers,
    'web-source': localStorage.getItem('source') || '',
    tid: localStorage.getItem('hero_tid') || '',
    hero_r: localStorage.getItem('hero_ri') || '',
    hero_pri: localStorage.getItem('hero_pri')  || '',
    guest_id: localStorage.getItem('guest_uid') || ''
  }
  return {
    ...config
  }
}, onError)

// 响应拦截
instance.interceptors.response.use((response: AxiosResponse) => {
  const { $customEvent } = UseReportData()
  $customEvent('wm_api_response', {
    url: response?.config?.url,
    data: response?.data
  })
  response && axiosCanceler.removePending(response.config)
  const { data } = response
  // token过期，清空绑定信息
  if (data.code === -20) {
    const { clearVerifyRole } = UseVerifyAccount()
    clearVerifyRole()
  }
  if (response && response.data) {
    return Promise.resolve(response)
  }
  return Promise.reject(new Error('response error'))
}, onError)

const request = async <T>(config: RequestConfigType): Promise<ResponseType<T>> => {
  try {
    const { data } = await instance.request<ResponseType<T>>(config)

    if (data.code === 0) {
      if (config.successToast) {
        ElMessage({
          message: data.msg || 'success',
          type: 'success'
        })
      }
      return data
    }

    if (config.errorToast) {
      ElMessage({
        message: data.msg,
        type: 'info'
      })
    }
    return data
  } catch (err: any) {
    console.error('err', err)
    return {
      code: -1000,
      msg: 'request error',
      data: null as any
    }
    // ElMessage({
    //   message: data.msg,
    //   type: 'info'
    // })
    // return data
  }
}

/**
 *
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const getRequest = <T>(
  url: string,
  params: object = {},
  successToast = false,
  errorToast = true
): Promise<ResponseType<T>> => {
  return request<T>({
    url,
    method: 'get',
    params,
    successToast,
    errorToast
  })
}

/**
 *  post接口默认提示成功和失败
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const postRequest = <T>(
  url: string,
  params: object,
  successToast = false,
  errorToast = true,
  headers = {}
): Promise<ResponseType<T>> => {
  return request<T>({
    url,
    method: 'post',
    data: params,
    headers: headers || {},
    successToast,
    errorToast
  })
}

/**
 *  post商城接口默认提示成功和失败，统一添加lang,access_token
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const postRequestMall = <T>(
  url: string,
  params: any,
  successToast = false,
  errorToast = true,
  headers = {}
): Promise<ResponseType<T>> => {
  const { currentLanguage } = useLanguageStore()

  const lang = CommonConstants.IS_AREA === 'cn' ? 'zh' : currentLanguage.key || 'en'
  // try {
  //
  //   // lang = JSON.parse(localStorage.getItem('languageStore') || '{}').currentLanguage.key || 'en'
  //   console.log('lang, getasdasd', lang, url)
  // } catch (error) {
  //   lang = 'en'
  // }
  // if (params?.lang) {
  //   console.log('lang===000>', lang, url)
  //   lang = params.lang
  // }
  const token = getMysToken() || getToken()
  // let token = getToken()
  // if (url.includes('/role/roles')) {
  //   token = getMysToken()
  // }
  return request<T>({
    url,
    method: 'post',
    data: {
      lang,
      data: params,
      access_token: token,
      web_source: localStorage.getItem('source') || '',
      tid: localStorage.getItem('hero_tid') || '',
      hero_r: localStorage.getItem('hero_ri') || '',
      hero_pri: localStorage.getItem('hero_pri')  || '',
      guest_id: localStorage.getItem('guest_uid') || ''
    },
    headers: headers || {},
    successToast,
    errorToast
  })
}

/**
 *  post接口默认提示成功和失败
 * @param url
 * @param params
 * @param successToast
 * @param errorToast
 */
export const deleteRequest = <T>(
  url: string,
  params: object = {},
  successToast = true,
  errorToast = true
): Promise<ResponseType<T>> => {
  return request<T>({
    url,
    method: 'delete',
    data: params,
    successToast,
    errorToast
  })
}

const getToken = () => {
  const { path } = window.globalRoute
  const localTokens = JSON.parse(localStorage.getItem('tokens') || '{}')
  return localTokens[path] || ''
}
// 获取摸鱼社的token
const getMysToken = () => {
  const { path } = window.globalRoute
  const localTokens = JSON.parse(localStorage.getItem('mysTokens') || '{}')
  return localTokens[path] || ''
}
